import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';

import { NotFound, RouteWithSubRoutes } from '@cordata/buffet';

import FacilitiesIndex from './collection';

const Facilities = ({ routes }) => {
  const { path, url } = useRouteMatch();

  return (
    <>
      <Switch>
        <Route
          exact
          path={url}
          render={() => <FacilitiesIndex />}
        />

        {routes.map(r => (
          <RouteWithSubRoutes key={r.path} {...r} path={`${path}/${r.path}`} />
        ))}

        <Route path="*"><NotFound isRoute /></Route>
      </Switch>
    </>
  );
};

export default Facilities;
